/**
 * Replaces template variables in outreach text with actual values.
 *
 * Supported variables:
 * - {{organization.name}} - Organization name
 * - {{organization.type}} - Organization type (residencies/schools)
 * - {{invitationLink}} - Invitation link URL
 * - {{couponCode}} - Coupon code
 */
export function populateOutreachVariables(
  text: string,
  organizationName?: string,
  organizationType?: "residencies" | "schools",
  invitationLink: string = "",
  couponCode: string = ""
): string {
  const defaultOrg = {
    name: "Your Organization",
    type: "residencies",
  };

  const org =
    organizationName && organizationType
      ? { name: organizationName, type: organizationType }
      : defaultOrg;

  return text
    .replace(/{{organization\.name}}/g, org.name)
    .replace(/{{organization\.type}}/g, org.type)
    .replace(/{{invitationLink}}/g, invitationLink)
    .replace(/{{couponCode}}/g, couponCode);
}

